<template>
    <div class="filterWrap">
        <!-- <nav-bar></nav-bar> -->
        <div class="content">
            <p class="title">
                区域
                <span>{{selectedCounty ? selectedCounty : "不限"}}</span>
            </p>
            <div class="districtWrap fr fw ac">
                <span @click="clearCounty" :class="isUnlimited ? 'active' : 'fade'">不限</span>
                <span
                    @click="selectCounty(index)"
                    class="ellipsis"
                    v-for="(item, index) in countyList"
                    :key="item.id"
                    :class="item.is_selected ? 'active' : 'fade'"
                >{{item.name}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { setTimeout } from "timers";
export default {
    data() {
        return {
            citycode: this.$route.query.citycode,
            countyList: [],
            selectedCounty: this.getLocal("selectedCounty") ? this.getLocal("selectedCounty") : "",
            isUnlimited: false
        };
    },
    components: {
        navBar
    },
    created() {
        this.getCountyList();
    },
    methods: {
        getCountyList() {
            this.$post({
                method: "movie.county.list",
                citycode: this.citycode
            }).then(res => {
                if (res.success) {
                    this.countyList = res.data.countylist;
                }
            });
        },
        selectCounty(idx) {
            for (let i in this.countyList) {
                if (i == idx) {
                    this.$set(
                        this.countyList[i],
                        "is_selected",
                        this.countyList[i].is_selected ? false : true
                    );
                } else {
                    this.$set(this.countyList[i], "is_selected", false);
                }
            }
            this.selectedCounty = this.countyList[idx].name;
            this.setLocal("countycode", this.countyList[idx].id);
            this.setLocal("selectedCounty", this.countyList[idx].name);
            let that = this
            setTimeout(function(){
                that.$router.go(-1)
            }, 600)
        },
        clearCounty(){
            this.removeLocal("countycode");
            this.removeLocal("selectedCounty");
            this.selectedCounty = "不限";
            this.isUnlimited = true;
            let that = this;
            setTimeout(function(){
                that.$router.go(-1)
            }, 600)
        }
    }
};
</script>
<style scoped lang="scss">
.filterWrap {
    background-color: #fff;
    .content {
        .title {
            height: 100px;
            line-height: 100px;
            padding: 0 25px;
            font-size: 28px;
            span {
                font-size: 26px;
                margin-left: 30px;
                color: #818181;
            }
        }
        .districtWrap {
            padding: 25px 0 25px 25px;
            span {
                width: 161px;
                height: 80px;
                line-height: 80px;
                text-align: center;
                padding: 0 2px;
                margin: 0 18px 18px 0;
                font-size: 26px;
            }
            .active {
                color: #ff5204;
                border: 1px solid #ff5204; /*no*/
            }
            .fade {
                color: #818181;
                border: 1px solid #ddd; /*no*/
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/search/districtFilter.vue